import { Outlet, useLocation } from "react-router-dom";
import { FoundryTopBar, type NavItem } from "../components/Chrome";
import type { TenantBranding } from "../types";

const BASE_NAV: NavItem[] = [
  { id: "home", label: "Home", to: "/admin" },
  { id: "people", label: "People", to: "/admin/people" },
  { id: "pages", label: "Pages", to: "/admin/pages" },
  { id: "branding", label: "Branding", to: "/admin/branding" },
  { id: "audit", label: "Audit", to: "/admin/audit" },
];

export function AdminLayout({
  branding,
  tenantSlug: _tenantSlug,
  isFoundryOwner = false,
}: {
  branding: TenantBranding;
  tenantSlug: string;
  isFoundryOwner?: boolean;
}) {
  const { pathname } = useLocation();
  const nav: NavItem[] = isFoundryOwner
    ? [...BASE_NAV, { id: "super", label: "All tenants", to: "/admin/super" }]
    : BASE_NAV;
  const active = pathname.startsWith("/admin/super")
    ? "super"
    : pathname.startsWith("/admin/people")
    ? "people"
    : pathname.startsWith("/admin/pages")
    ? "pages"
    : pathname.startsWith("/admin/branding")
    ? "branding"
    : pathname.startsWith("/admin/audit")
    ? "audit"
    : "home";
  return (
    <div className="admin-shell">
      <FoundryTopBar
        nav={nav}
        activeId={active}
        tenantName={branding.display_name}
        tenantColor={branding.primary_color}
      />
      <div className="admin-body">
        <Outlet />
      </div>
    </div>
  );
}
